import $axios from './api';

export const list = async ( payload = {} ) => {
	const { data } = await $axios.post('/v1/author/audience/list', payload);
	return data;
};